// Centralized menu data for Dashboard
export const manageData = [
  { label: "Policy Entry", path: "/life-policy-entry" },
  { label: "Life Product Master", path: "/life-product" },
  { label: "Policy Alteration" },
  { label: "FUP Date Batch Update", path: "/fup-update" },
  { label: "Premium Deposits", path: "/premium-deposit-entry-list" },
  { label: "ULIP Unit Adjustments" },
];

export const importData = [
  { label: "Create File Structure" },
  { label: "Import Policies from Excel", path: "/import-policy-report" },
];

export const customerPresentations = [
  { label: "Premium Calendar" },
  { label: "Cash Flow Chart" },
  { label: "Comprehensive Insurance Chart" },
  { label: "Premium Paid Details" },
];

export const preSalesTools = [
  { label: "Human Life Value Calculator" },
  { label: "Income Replacement Calculator" },
  { label: "Retirement Needs Calculator" },
  { label: "Child Education Needs Calculator" },
];

export const businessAnalytics = [
  { label: "Top Customers List" },
  { label: "Product Wise Business" },
  { label: "Premium Per Lac SA" },
  { label: "Age Wise Business Analysis" },
  { label: "Policies DrillDown" },
];

export const licReports = [
  { label: "Policy Register", path: "/life-policy-register" },
  { label: "Current Status Register", path: "/current-status-report" },
  { label: "Premium Due", path: "/premium-due-report" },
  { label: "Premium Outstanding", path: "/premium-outstanding-report" },
  { label: "Lapsed Policy", path: "/lapsed-policy-report" },
  { label: "Policy Maturity", path: "/maturity-policies-report" },
  { label: "Survival Benefit" },
  { label: "Cash Flow Chart" },
  { label: "Comprehensive Insurance Chart" },
  { label: "Annuity Statement" },
];

export const licCommReports = [
  { label: "Commission Ledger" },
  { label: "Commission Bill" },
  { label: "Deduction Summary" },
  { label: "Commission Summary" },
];

export const specialPlans = [
  { label: "New Endowment Plan - 714" },
  { label: "New Jeevan Anand - 715" },
  { label: "Single Premium Endowment - 717" },
  { label: "Jeevan Lakshya - 733" },
  { label: "Jeevan Tarun - 734" },
  { label: "Jeevan Labh - 736" },
  { label: "Jeevan Umang - 745" },
  { label: "Jeevan Utsav - 771" },
  { label: "AmritBaal - 774" },
  { label: "Bima Jyoti - 760" },
  { label: "Moneyback - 20 Years - 720" },
  { label: "Bima Shree - 748" },
  { label: "Yuva Term - 875" },
  { label: "New Money Back 25 Years - 721" },
  { label: "New Jeevan Amar - 955" },
  { label: "Jeevan Akshay - 857" },
  { label: "Index Plus - 873" },
  { label: "Nivesh Plus - 749" },
  { label: "New Jeevan Shanti - 758" },
  { label: "New Endowment Plus - 735" },
  { label: "SIIP - 752" },
  { label: "Saral Jeevan Bima - 859" },
  { label: "Jeevan Azad - 768" },
  { label: "New Pension Plus - 867" },
];

export const multiInsurer = [
  { label: "Follow Up Reports" },
  { label: "Premiums Due" },
  { label: "Premiums Outstanding" },
  { label: "Cash Flow Due" },
  { label: "Annuity Due Statement" },
  { label: "Life Insurance Requests" },
];

export const backOffice = [
  { label: "Policy Register" },
  { label: "Premium Deposits Register" },
  { label: "Renewal Calendar" },
];

export const newDataEntry = [
  { label: "Premium Deposit Entry", path: "/premium-deposit-entry" },
  { label: "Family History" },
  { label: "Medical History" },
  { label: "Policy Query" },
];

export const licPresentation = [
  { label: "CKR Mix" },
  { label: "CKR Concept" },
];

export const withdrawnPlans = [{ label: "(list of withdrawn plans)" }];

// Admin / Other top-level menus
export const adminMenuItems = [
  { label: "Roles", path: "/roles" },
  { label: "Role Privilege", path: "/role-privilege" },
  { label: "Employee Master", path: "/employee-master" },
  { label: "Theme Master", path: "/theme-master" },
];

export const generalMenuItems = [
  { label: "Policy Entry" },
  { label: "Premium Due" },
  { label: "Claim Register" },
  { label: "Customer Details" },
];

export const commonMenuItems = [
  { label: "Group Master", path: "/group-master" },
  { label: "Company Master", path: "/company-master" },
  { label: "Agent Master", path: "/agent-master" },
  { label: "Customer Master", path: "/customer-master" },
];

// Grouped sections for General Insurance (mega menu)
export const generalSections = [
  {
    title: "Masters",
    items: [
      { label: "Motor Add-On Master" },
      { label: "Float Account Master" },
      { label: "Commission Rates" },
      { label: "Motor Settings" },
      { label: "TPA Contacts" },
    ],
  },
  {
    title: "Transactions",
    items: [
      { label: "Health Insurance Policies", path: "/health-insurance" },
      { label: "Motor Insurance Policies", path: "/motor-product" },
      { label: "Other Insurance Policies", path: "/other-insurance" },
      { label: "Personal Accident Policies" },
      { label: "Import Policies from Excel", path: "/import-policy-report" },
    ],
  },
  {
    title: "Quotations",
    items: [
      { label: "Health Insurance Quotes", path: "/health-insurance" },
      { label: "Motor Insurance Quotes", path: "/motor-product" },
      { label: "Other Insurance Quotes", path: "/other-insurance" },
      { label: "Health Comparative Quotes" },
    ],
  },
  {
    title: "Claims",
    items: [
      { label: "Claims Browser" },
      { label: "Claim Intimation" },
      { label: "Claim Covering Letter" },
      { label: "TPA List" },
      { label: "Claim Forms" },
    ],
  },
  {
    title: "Reports",
    items: [
      { label: "Policy Register", path: "/policy-register" },
      { label: "Policy Fact Sheet" },
      { label: "Health Insurance Requests" },
      { label: "Policy Not Received List" },
    ],
  },
  {
    title: "Business Analytics",
    items: [
      { label: "Policies Drill Down" },
      { label: "Top Customers List" },
      { label: "Product wise Business" },
      { label: "Business Comparison" },
    ],
  },
];

// Grouped sections for Other Investments (mega menu)
export const otherInvestmentSections = [
  {
    title: "Masters",
    items: [
      { label: "Investment Scheme Master" },
      { label: "PPF Account Master" },
      { label: "PMS Master" },
    ],
  },
  {
    title: "Transactions",
    items: [
      { label: "Postal Investments" },
      { label: "FDs & RDs" },
      { label: "PPF" },
      { label: "Bonds" },
      { label: "Debentures" },
    ],
  },
  {
    title: "Import Data",
    items: [
      { label: "FDs & RD Import" },
      { label: "PPF Import" },
    ],
  },
  {
    title: "Reports",
    items: [
      { label: "RD Installment Due" },
      { label: "FD & RD Maturities" },
      { label: "PPF Maturities" },
    ],
  },
  {
    title: "CRM",
    items: [
      { label: "Investments Chart" },
      { label: "PPF Passbook" },
    ],
  },
];

// Grouped sections for Common (mega menu)
export const commonSections = [
  {
    title: "Customer Management",
    items: [
      { label: "Active / Inactive Customer List", path: "/active-inactive-customer" },
      { label: "Agency Master", path: "/agency" },
      { label: "Area Master", path: "/area-master-list" },
      { label: "Branch Master", path: "/branch" },
      { label: "Customer Master", path: "/customer" },
      { label: "Group Master", path: "/group" },
      { label: "Vehicle Master", path: "/vehicle" },
    //   { label: "Customer Groups (Families)" },
    //   { label: "Customer Groups" },
    //   { label: "Merge Customers" },
    //   { label: "Customer Browser" },
    //   { label: "Import Customers" },
    ],
  },
  {
    title: "Consolidated",
    items: [
      { label: "CRM Centre" },
      { label: "Consolidated Insurance Portfolio" },
      { label: "Common Premium Due" },
    ],
  },
  {
    title: "Reports",
    items: [
      { label: "Composite Premium Calendar" },
      { label: "Mailing Label" },
      { label: "Active Customers" },
    ],
  },
  {
    title: "Task Management",
    items: [
      { label: "Task Type Master" },
      { label: "Task Status Master" },
      { label: "Task FollowUp Master" },
    ],
  },
];

// Grouped sections for Admin (mega menu)
export const adminSections = [
  {
    title: "User Management",
    items: [
      { label: "Roles Master", path: "/roles" },
      { label: "Role Privileges", path: "/role-privilege" },
      { label: "Employee Master", path: "/employee-master" },
      { label: "Theme Master", path: "/theme-master" },
      { label: "User Master" },
      { label: "Relationship Manager Mapping" },
    ],
  },
  {
    title: "Organization",
    items: [
    //   { label: "Agency Master", path: "/agency" },
    //   { label: "Branches", path: "/branch" },
      { label: "Employees", path: "/employee-master" },
      { label: "Principal Broker" },
    ],
  },
  {
    title: "Settings",
    items: [
      { label: "Application Configuration" },
      { label: "My-Insurance Setup" },
      { label: "Customer Login Management" },
      { label: "Edit Profile", path: "/my-profile" },
    ],
  },
  {
    title: "My Account",
    items: [
      { label: "Subscription Details" },
      { label: "Upgrade Subscription level" },
      { label: "Change Payment Mode" },
      { label: "Download Invoice" },
    ],
  },
  {
    title: "Alerts & Notifications",
    items: [
      { label: "Intimation Templates" },
      { label: "Scheduling Services" },
      { label: "Scheduled Reports Management" },
    ],
  },
];
